import apiClient from "./config";
import { TESTIMONY_ENDPOINTS } from "./endpoints";

const testimonyService = {
  // Get Search Results
  testimony: (data) => {
    return apiClient.get(TESTIMONY_ENDPOINTS.TESTIMONY , { params: data });
  },
 

};

export default testimonyService;